import { render, staticRenderFns } from "./CustomMessageInput.vue?vue&type=template&id=a6e177f6&scoped=true"
import script from "./CustomMessageInput.vue?vue&type=script&lang=js"
export * from "./CustomMessageInput.vue?vue&type=script&lang=js"
import style0 from "./CustomMessageInput.vue?vue&type=style&index=0&id=a6e177f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6e177f6",
  null
  
)

export default component.exports